var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"suggestion-certificate",attrs:{"href":_vm.url,"rel":"noopener nofollow","target":"_blank"}},[_c('base-icon',{attrs:{"name":"doc-solid","width":"16","height":"16"}}),_vm._v(" Сертификат ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }